module.exports = __webpack_public_path__ + "img/mexico.e75f3c3c.svg";